/** biome-ignore-all lint/suspicious/noConsole: We dont have logger here */
/**
 * Utility to detect user's country from IP address
 * Based on the existing implementation in the chat module
 */

export interface CountryInfo {
  country: string
  region: string
  city: string
  org: string
  ip: string
  postal: string
  timezone: string
}

/**
 * Get country code from user's IP address using ipinfo.io
 * @returns Promise that resolves to country information or null if failed
 */
export const getCountryFromIP = async (): Promise<CountryInfo | null> => {
  try {
    const response = await fetch('https://ipinfo.io/json')
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }
    const data = await response.json()
    return data
  } catch (error) {
    console.error('getCountryFromIP - Failed to get country code', error)
    return null
  }
}

/**
 * Get just the country code from IP address
 * @returns Promise that resolves to country code (e.g., 'US', 'IN') or null
 */
export const getCountryCodeFromIP = async (): Promise<string | null> => {
  const countryInfo = await getCountryFromIP()
  return countryInfo?.country || null
}
